module.exports = __webpack_public_path__ + "img/notebook-graphics-gray.8cca5059.png";